import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconControl, PsBeaconControlGroup } from '../shared/BeaconRegister';
import { InvestmentInfoContent } from './ConsentContent';
import { listStyle } from '../../Utils';

const YodleeConsentSection = ({ handleChange, idSuffix = '' }) => {
    const termsContainerId = idSuffix
        ? `aggregation-terms-container-${idSuffix}`
        : 'aggregation-terms-container';
    const aggregationTermsId = idSuffix
        ? `yodlee-aggregation-terms-${idSuffix}`
        : 'yodlee-aggregation-terms';

    return (
        <Box id="yodlee-consent-container" sx={{ padding: idSuffix === 'panel' ? '24px' : undefined }}>
            <div>
                <Typography
                    type="body" scale={200} bold
                    id="yodlee-consent-header"
                    sx={{ paddingBottom: '16px' }}>
                    {InvestmentInfoContent.aggregationSection.header}
                </Typography>
                <Typography
                    type="body" loose scale={100} light
                    id="yodlee-consent-body"
                    sx={{ paddingBottom: '40px' }}>
                    {InvestmentInfoContent.aggregationSection.content}
                </Typography>
            </div>
            <Box>
                <Typography
                    type="body" scale={100} bold
                    id="yodlee-consent-sub-header"
                    sx={{ paddingBottom: '16px' }}>
                    {InvestmentInfoContent.aggregationSection.subHeader}
                </Typography>
                <Typography
                    type="body" loose scale={100} light
                    id="yodlee-consent-terms-content"
                    sx={{ paddingBottom: '40px' }}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: InvestmentInfoContent.aggregationSection.contentSub,
                        }}
                    />
                </Typography>
            </Box>
            <Box
                id="yodlee-bullet-points-container"
                sx={{ paddingBottom: '40px' }}>
                {InvestmentInfoContent.aggregationSection.bulletPoints.map((o) => (
                    <Typography
                        key={o.bulletKey}
                        type="body" loose scale={100} light
                        id={o.bulletKey}>
                        <ul style={{ ...listStyle }}>
                            <li
                                dangerouslySetInnerHTML={{
                                    __html: o.bullet,
                                }}
                            />
                        </ul>
                    </Typography>
                ))}
            </Box>
            <Box id="yodlee-notice-container" sx={{ paddingBottom: '40px' }}>
                <Typography
                    type="body" scale={100} light
                    id="yodlee-notice-content">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: InvestmentInfoContent.aggregationSection.notice,
                        }}
                    />
                </Typography>
            </Box>
            <Typography
                type="body" scale={100} light
                id="service-content-container"
                sx={{ paddingBottom: '40px' }}>
                <Box id="yodlee-service-content">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: InvestmentInfoContent.aggregationSection.serviceContent,
                        }}
                    />
                </Box>
            </Typography>
            <Typography
                type="body" scale={100} light
                id={termsContainerId}
                sx={{ paddingBottom: '40px' }}>
                <Box variant="body2" gutterBottom id={aggregationTermsId}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: InvestmentInfoContent.aggregationSection.aggregationTerms,
                        }}
                    />
                </Box>
            </Typography>
            <PsBeaconControlGroup>
                <PsBeaconControl inline>
                    <label
                        slot="label"
                        id="agreementYodlee-label"
                        htmlFor="agreementYodlee">
                        I agree
                    </label>
                    <input
                        type="checkbox"
                        name="agreementYodlee"
                        id="agreementYodlee"
                        onChange={handleChange('checkedYodlee')}
                    />
                </PsBeaconControl>
            </PsBeaconControlGroup>
        </Box>
    );
};

export default YodleeConsentSection;
